<mad-data-table
  [idGenerator]="idGenerator"
  [parentIdGenerator]="parentIdGenerator"
  [displayedColumns]="displayedColumns"
  [tableData]="tableData"
  [actions]="actions"
  [paginationEnabled]="false"
  (actionEvent)="handleActionEvent($event)"
>
</mad-data-table>
